import * as React from "react";
const SvgConstraintsHorizontal = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 15V9H4V11H20V9H22V15H20V13H4V15H2Z", fill: "currentColor" }));
export default SvgConstraintsHorizontal;
